import {
  TableContainer as NovaTableContainerBase,
  TableContainerProps as NovaTableContainerProps,
} from '@fme-nova/components'
import {
  default as MuiTableContainerBase,
  TableContainerProps as MuiTableContainerProps,
} from '@mui/material/TableContainer'

import { styled, uiTokens } from '../../theme'
import { createComponentWrapperWithRef } from '../../theme'
import { COLORS } from '../../theme/colors'
import { TableMode } from './TableMode'

export type TableContainerProps = MuiTableContainerProps & { $mode?: TableMode; $hideTopBorder?: boolean }

const MuiTableContainer = styled(MuiTableContainerBase, {
  shouldForwardProp: (prop) => prop !== '$mode' && prop !== '$hideTopBorder',
})<{
  $mode?: TableMode
  $hideTopBorder?: boolean
}>`
  ${(props) => (props.$mode === 'Default' || !props.$mode) && `border: 1px solid ${COLORS.divider};`}
  display: flex;
  flex-direction: column;
  ${(props) => (props.$mode === 'Default' || !props.$mode) && `border-radius: 8px;`}
  background-color: ${COLORS.components.table.background};
  ${(props) => props.$hideTopBorder && `border-top: none;`}
  ${(props) => props.$hideTopBorder && `border-top-left-radius: 0;`}
  ${(props) => props.$hideTopBorder && `border-top-right-radius: 0;`}
`

const NovaTableContainer = styled(NovaTableContainerBase, {
  shouldForwardProp: (prop) => prop !== '$mode' && prop !== '$hideTopBorder',
})<{
  $mode?: TableMode
  $hideTopBorder?: boolean
}>`
  display: flex;
  flex-direction: column;
  ${(props) => (props.$mode === 'Default' || !props.$mode) && `background-color: white;`}
  ${(props) => (props.$mode === 'Default' || !props.$mode) && `border-radius: ${uiTokens.radius.large}px;`}
`

export const TableContainer = createComponentWrapperWithRef<TableContainerProps | NovaTableContainerProps>(
  {
    mui: MuiTableContainer,
    nova: NovaTableContainer,
  },
  'TableContainer',
)
